import {HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, switchMap} from 'rxjs';
import {TokenService} from '../services/token.service';
import {SessionManagerService} from '../services/session-manager.service';
import {AuthService} from '../../features/auth/services/auth.service';
import {JwtToken} from '../../shared/models/JwtToken';

let isRefreshing = false;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const sessionManagerService = inject(SessionManagerService);
  const authService = inject(AuthService);

  // Skip auth header for auth endpoints (except refresh)
  if (req.url.includes('/auth/') && !req.url.includes('/auth/refresh')) {
    return next(req);
  }

  if (!sessionManagerService.loggedIn()) {
    return next(req);
  }

  // Check if token needs refresh (< 1 day remaining)
  if (tokenService.needsRefresh() && !isRefreshing && !req.url.includes('/auth/refresh')) {
    isRefreshing = true;

    return authService.updateToken(null).pipe(
      switchMap((jwtToken: JwtToken) => {
        sessionManagerService.saveToken(jwtToken);
        isRefreshing = false;

        const clonedReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${jwtToken.token}`,
          },
        });
        return next(clonedReq);
      }),
      catchError(() => {
        isRefreshing = false;
        return next(addAuthHeader(req, tokenService));
      })
    );
  }

  return next(addAuthHeader(req, tokenService));
};

function addAuthHeader(req: HttpRequest<unknown>, tokenService: TokenService) {
  const token = tokenService.token();
  if (token) {
    return req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  return req;
}
